import {useState, useEffect} from "react";

export const EquipmentRequest = ({onUpdate, active, isViewOnly = false, initialData}) => {

    const [equipmentRequestForm, setEquipmentRequestForm] = useState({
        tables6ft: '',
        tables8ft: '',
        roundTables: '',
        foldingWhiteChairs: '',
        foldingBrownChairs: '',
        greenChairs: '',
        trashCans: '',
        projectorScreen: false,
        extensionCords: '',
        tvMoved: false,
        tvLocation: '',
        otherEquipment: '',
        setupInstructions: ''
    });

    // Populate form with initial data when provided
    useEffect(() => {
        if (initialData && Object.keys(initialData).length > 0) {
            setEquipmentRequestForm(prevState => ({
                ...prevState,
                ...initialData
            }));
        }
    }, [initialData]);

    const handleChange = (event) => {
        const { name, type, value, checked } = event.target;
        const newValue = type === 'checkbox' ? checked : value;
        const newData = { ...equipmentRequestForm, [name]: newValue };
        setEquipmentRequestForm(newData);
        onUpdate(newData);
    };

    if (!active) return null; // Only render if active

    return (
        <div className="rounded-lg">
            <div className="grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6">
                <div className="sm:col-span-6">
                    <p className="text-sm text-gray-500 mb-4">Enter the quantity of equipment needed for your event. Leave blank if not required.</p>
                </div>

                {/* Tables & Chairs */}
                <div className="sm:col-span-2">
                    <label htmlFor="tables6ft" className="block text-sm font-medium text-gray-700">6' Rectangle Tables</label>
                    <div className="mt-1">
                        <input
                            type="number"
                            name="tables6ft"
                            id="tables6ft"
                            min="0"
                            value={equipmentRequestForm.tables6ft}
                            onChange={handleChange}
                            disabled={isViewOnly}
                            readOnly={isViewOnly}
                            className={`shadow-sm ${!isViewOnly ? 'focus:ring-indigo-500 focus:border-indigo-500' : ''} block w-full sm:text-sm ${isViewOnly ? 'bg-gray-100' : 'border-gray-300'} rounded-md`}
                            placeholder="0"
                        />
                    </div>
                </div>

                <div className="sm:col-span-2">
                    <label htmlFor="tables8ft" className="block text-sm font-medium text-gray-700">8' Rectangle Tables</label>
                    <div className="mt-1">
                        <input
                            type="number"
                            name="tables8ft"
                            id="tables8ft"
                            min="0"
                            value={equipmentRequestForm.tables8ft}
                            onChange={handleChange}
                            disabled={isViewOnly}
                            readOnly={isViewOnly}
                            className={`shadow-sm ${!isViewOnly ? 'focus:ring-indigo-500 focus:border-indigo-500' : ''} block w-full sm:text-sm ${isViewOnly ? 'bg-gray-100' : 'border-gray-300'} rounded-md`}
                            placeholder="0"
                        />
                    </div>
                </div>

                <div className="sm:col-span-2">
                    <label htmlFor="roundTables" className="block text-sm font-medium text-gray-700">Round Tables</label>
                    <div className="mt-1">
                        <input
                            type="number"
                            name="roundTables"
                            id="roundTables"
                            min="0"
                            value={equipmentRequestForm.roundTables}
                            onChange={handleChange}
                            disabled={isViewOnly}
                            readOnly={isViewOnly}
                            className={`shadow-sm ${!isViewOnly ? 'focus:ring-indigo-500 focus:border-indigo-500' : ''} block w-full sm:text-sm ${isViewOnly ? 'bg-gray-100' : 'border-gray-300'} rounded-md`}
                            placeholder="0"
                        />
                    </div>
                </div>

                <div className="sm:col-span-6">
                    <label className="block text-sm font-medium text-gray-700 mb-2">Chairs</label>
                    <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
                        <div>
                            <label htmlFor="foldingWhiteChairs" className="block text-sm font-medium text-gray-500">Folding White Chairs</label>
                            <div className="mt-1">
                                <input
                                    type="number"
                                    name="foldingWhiteChairs"
                                    id="foldingWhiteChairs"
                                    min="0"
                                    value={equipmentRequestForm.foldingWhiteChairs}
                                    onChange={handleChange}
                                    disabled={isViewOnly}
                                    readOnly={isViewOnly}
                                    className={`shadow-sm ${!isViewOnly ? 'focus:ring-indigo-500 focus:border-indigo-500' : ''} block w-full sm:text-sm ${isViewOnly ? 'bg-gray-100' : 'border-gray-300'} rounded-md`}
                                    placeholder="0"
                                />
                            </div>
                        </div>

                        <div>
                            <label htmlFor="foldingBrownChairs" className="block text-sm font-medium text-gray-500">Folding Brown Chairs</label>
                            <div className="mt-1">
                                <input
                                    type="number"
                                    name="foldingBrownChairs"
                                    id="foldingBrownChairs"
                                    min="0"
                                    value={equipmentRequestForm.foldingBrownChairs}
                                    onChange={handleChange}
                                    disabled={isViewOnly}
                                    readOnly={isViewOnly}
                                    className={`shadow-sm ${!isViewOnly ? 'focus:ring-indigo-500 focus:border-indigo-500' : ''} block w-full sm:text-sm ${isViewOnly ? 'bg-gray-100' : 'border-gray-300'} rounded-md`}
                                    placeholder="0"
                                />
                            </div>
                        </div>

                        <div>
                            <label htmlFor="greenChairs" className="block text-sm font-medium text-gray-500">Green Chairs</label>
                            <div className="mt-1">
                                <input
                                    type="number"
                                    name="greenChairs"
                                    id="greenChairs"
                                    min="0"
                                    value={equipmentRequestForm.greenChairs}
                                    onChange={handleChange}
                                    disabled={isViewOnly}
                                    readOnly={isViewOnly}
                                    className={`shadow-sm ${!isViewOnly ? 'focus:ring-indigo-500 focus:border-indigo-500' : ''} block w-full sm:text-sm ${isViewOnly ? 'bg-gray-100' : 'border-gray-300'} rounded-md`}
                                    placeholder="0"
                                />
                            </div>
                        </div>
                    </div>
                </div>

                <div className="sm:col-span-3">
                    <label htmlFor="trashCans" className="block text-sm font-medium text-gray-700">Trash Cans</label>
                    <div className="mt-1">
                        <input
                            type="number"
                            name="trashCans"
                            id="trashCans"
                            min="0"
                            value={equipmentRequestForm.trashCans}
                            onChange={handleChange}
                            disabled={isViewOnly}
                            readOnly={isViewOnly}
                            className={`shadow-sm ${!isViewOnly ? 'focus:ring-indigo-500 focus:border-indigo-500' : ''} block w-full sm:text-sm ${isViewOnly ? 'bg-gray-100' : 'border-gray-300'} rounded-md`}
                            placeholder="0"
                        />
                    </div>
                </div>

                {/* Technical Equipment */}
                <div className="sm:col-span-6">
                    <div className="border-t border-gray-200 pt-4">
                        <h4 className="text-sm font-medium text-gray-700">Additional Equipment</h4>
                    </div>
                </div>

                <div className="sm:col-span-3">
                    <div className="flex items-start">
                        <div className="flex items-center h-5">
                            <input
                                type="checkbox"
                                name="projectorScreen"
                                id="projectorScreen"
                                checked={equipmentRequestForm.projectorScreen}
                                onChange={handleChange}
                                disabled={isViewOnly}
                                className={`${!isViewOnly ? 'focus:ring-indigo-500' : ''} h-4 w-4 ${isViewOnly ? 'bg-gray-100' : 'text-indigo-600'} border-gray-300 rounded`}
                            />
                        </div>
                        <div className="ml-3 text-sm">
                            <label htmlFor="projectorScreen" className="font-medium text-gray-700">Projector & Screen</label>
                        </div>
                    </div>
                </div>

                <div className="sm:col-span-3">
                    <div className="flex items-start">
                        <div className="flex items-center h-5">
                            <input
                                type="checkbox"
                                name="tvMoved"
                                id="tvMoved"
                                checked={equipmentRequestForm.tvMoved}
                                onChange={handleChange}
                                disabled={isViewOnly}
                                className={`${!isViewOnly ? 'focus:ring-indigo-500' : ''} h-4 w-4 ${isViewOnly ? 'bg-gray-100' : 'text-indigo-600'} border-gray-300 rounded`}
                            />
                        </div>
                        <div className="ml-3 text-sm">
                            <label htmlFor="tvMoved" className="font-medium text-gray-700">TV/Display Move Required</label>
                        </div>
                    </div>

                    {equipmentRequestForm.tvMoved && (
                        <div className="mt-3 ml-7">
                            <input
                                type="text"
                                name="tvLocation"
                                id="tvLocation"
                                value={equipmentRequestForm.tvLocation}
                                onChange={handleChange}
                                disabled={isViewOnly}
                                readOnly={isViewOnly}
                                className={`shadow-sm ${!isViewOnly ? 'focus:ring-indigo-500 focus:border-indigo-500' : ''} block w-full sm:text-sm ${isViewOnly ? 'bg-gray-100' : 'border-gray-300'} rounded-md`}
                                placeholder="Specify location for TV/display"
                            />
                        </div>
                    )}
                </div>

                <div className="sm:col-span-3">
                    <label htmlFor="extensionCords" className="block text-sm font-medium text-gray-700">Extension Cords</label>
                    <div className="mt-1">
                        <input
                            type="number"
                            name="extensionCords"
                            id="extensionCords"
                            min="0"
                            value={equipmentRequestForm.extensionCords}
                            onChange={handleChange}
                            disabled={isViewOnly}
                            readOnly={isViewOnly}
                            className={`shadow-sm ${!isViewOnly ? 'focus:ring-indigo-500 focus:border-indigo-500' : ''} block w-full sm:text-sm ${isViewOnly ? 'bg-gray-100' : 'border-gray-300'} rounded-md`}
                            placeholder="0"
                        />
                    </div>
                </div>

                <div className="sm:col-span-3">
                    <label htmlFor="otherEquipment" className="block text-sm font-medium text-gray-700">Other Equipment Needed</label>
                    <div className="mt-1">
                        <input
                            type="text"
                            name="otherEquipment"
                            id="otherEquipment"
                            value={equipmentRequestForm.otherEquipment}
                            onChange={handleChange}
                            disabled={isViewOnly}
                            readOnly={isViewOnly}
                            className={`shadow-sm ${!isViewOnly ? 'focus:ring-indigo-500 focus:border-indigo-500' : ''} block w-full sm:text-sm ${isViewOnly ? 'bg-gray-100' : 'border-gray-300'} rounded-md`}
                            placeholder="Specify any other equipment needed"
                        />
                    </div>
                </div>

                <div className="sm:col-span-6">
                    <label htmlFor="setupInstructions" className="block text-sm font-medium text-gray-700">Setup Instructions</label>
                    <div className="mt-1">
                        <textarea
                            name="setupInstructions"
                            id="setupInstructions"
                            rows="3"
                            value={equipmentRequestForm.setupInstructions}
                            onChange={handleChange}
                            disabled={isViewOnly}
                            readOnly={isViewOnly}
                            className={`shadow-sm ${!isViewOnly ? 'focus:ring-indigo-500 focus:border-indigo-500' : ''} block w-full sm:text-sm ${isViewOnly ? 'bg-gray-100' : 'border-gray-300'} rounded-md`}
                            placeholder="Provide detailed instructions for equipment setup"
                        />
                    </div>
                    <p className="mt-2 text-sm text-gray-500">Please include any special arrangements or configurations needed.</p>
                </div>
            </div>
        </div>
    );
}
